import React, { Component } from 'react';
import {Topic, TextHolder, Footer, ExploreData} from '../../Components/contentHolders/contentHolders.js';








export class ChapterNinety extends Component {

  render() {
    return (
      <section className="Content">
        <div className="content-holder-topic">
        <div className="content-holder-inner fade">

        <Topic topicNumber={this.props.topicNumber} topicTitle={this.props.topicTitle} topicText={this.props.topicText} />

        <TextHolder text="The SEA tech ecosystem has built up enormous momentum that is likely to result in strong growth going forward. In 2019 and beyond, we predict total funding and deal count to continue growing as they have over the past five years. Ecosystem interactions will increasingly cross borders as startups seek new markets and VCs expand their portfolio and investments to emerging opportunities in other countries. Regional integration will tighten, yielding an environment that is friendlier to swift international expansion. Acquisitions will likely remain the most common way for startups to exit, whether they are acquired by Chinese tech giants or local conglomerates. However, a few of the region’s unicorns could have promising IPOs on the horizon, following Sea Limited’s lead. Here are a few more of our predictions for what’s coming next in SEA." />

        <ExploreData nextChapter={ this.props.nextChapter } />
        <Footer />
        </div>
        </div>
      </section>

    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Content/90.js